import { Component, Inject, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent {
  @ViewChild('avatarInput') avatarInput!: ElementRef<HTMLInputElement>;
  selectedFiles: File[] = [];
  selectedAvatars: { file: File; url: string }[] = [];
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { 
      title: string; 
      content?: TemplateRef<any> | string; 
      closeFn?: () => void;
      cancelText?: string;
      confirmText?: string;
      isConfirmation?: boolean;
      isTemplateSelection?: boolean;
      templateList?: any[];
      selectedTemplateId?: number;
    },
    private dialogRef: MatDialogRef<DialogComponent>
  ) { }

  triggerFileInput(): void {
    this.avatarInput.nativeElement.click();
  }
  
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.selectedFiles = Array.from(input.files);
    }
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  onAvatarSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const files = Array.from(input.files);
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.selectedAvatars.push({ file, url: reader.result as string });
        };
        reader.readAsDataURL(file);
      });
    }
  }

  removeAvatar(index: number): void {
    this.selectedAvatars.splice(index, 1);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(): void {}

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer && event.dataTransfer.files) {
      const files = Array.from(event.dataTransfer.files).filter(file => 
        file.type.startsWith('image/')
      );

      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          this.selectedAvatars.push({ file, url: reader.result as string });
        };
        reader.readAsDataURL(file);
      });
    }
  }

  saveFiles(): void {
    if (this.selectedFiles.length === 0) {
      alert('Vui lòng chọn ít nhất một file!');
      return;
    }

    // Xử lý tải file lên server hoặc lưu file
    console.log('Các file đã chọn:', this.selectedFiles);

    alert('Đã lưu thông tin thành công!');
  }

  // Phương thức kiểm tra có phải dialog xác nhận không
  isConfirmationDialog(): boolean {
    return this.data.isConfirmation === true;
  }

  // Phương thức kiểm tra có phải dialog chọn template không
  isTemplateSelectionDialog(): boolean {
    return this.data.isTemplateSelection === true;
  }

  // Phương thức xử lý khi nhấn nút hủy
  onCancel(): void {
    this.dialogRef.close(false);
  }

  // Phương thức xử lý khi nhấn nút xác nhận
  onConfirm(): void {
    this.dialogRef.close(true);
  }

  // Phương thức chọn template
  selectTemplate(templateId: number): void {
    this.data.selectedTemplateId = templateId;
  }

  // Phương thức kiểm tra template có được chọn không
  isTemplateSelected(templateId: number): boolean {
    return this.data.selectedTemplateId === templateId;
  }

  // Phương thức xác nhận chọn template
  confirmTemplateSelection(): void {
    if (this.data.selectedTemplateId) {
      this.dialogRef.close(this.data.selectedTemplateId);
    } else {
      this.dialogRef.close(null);
    }
  }
}
